import React from "react";
import i18n from "i18n";
import { administrativeDashboardTypes } from "./AdministrativeDashboard/types";

export const getTitle = (reporterName: string) => {
  const currentTime = new Date();
  const hour = currentTime.getHours();

  let greeting;

  if (hour >= 6 && hour < 12) {
    greeting = i18n.t("goodMorning");
  } else if (hour >= 12 && hour < 18) {
    greeting = i18n.t("goodAfternoon");
  } else {
    greeting = i18n.t("goodEvening");
  }

  return `${greeting}, ${reporterName}!`;
};

const defaultSelectOptions = ["weekly", "monthly", "perYear"]; // 7 / 30 / 365

export const datePeriodOptions = (
  <>
    {defaultSelectOptions.map((option) => (
      <option key={option} value={option}>
        {i18n.t(option)}
      </option>
    ))}
  </>
);

export const administrativeMockData: administrativeDashboardTypes = {
  volunteerRegistrationData: {
    uuidsCount: 500,
    usersCount: 125,
    uuidBasedUserPercentage: 25,
    usersBasedMimshalZaminVerifyPercentage: 75,
  },
  reportCompletedByRoles: {
    controlCenter: {
      reportCompleted: 84,
      percentageByCompleteOrNot: 24,
      trendPercentageByPeriod: 17,
      trendIsIncrease: true,
      chartData: [120, 50, 100, 70, 90, 60, 20, 100, 170, 80, 60, 20],
    },
    regularController: {
      reportCompleted: 84,
      percentageByCompleteOrNot: 24,
      trendPercentageByPeriod: 12,
      trendIsIncrease: true,
      chartData: [20, 50, 100, 70, 80, 160, 20, 100, 70, 80, 60, 120],
    },
    seniorController: {
      reportCompleted: 84,
      percentageByCompleteOrNot: 65,
      trendPercentageByPeriod: 15,
      trendIsIncrease: false,
      chartData: [20, 50, 100, 170, 80, 60, 120, 100, 70, 180, 60, 20],
    },
  },
  reportCompletedByRolesTotalAmount: 120,
  reportCompletedByControlCenterDetails: {
    reportCompletedPerControlCenter: {
      "אור גלר": 500,
      "שלמה כהן": 700,
      "אריאל גבע": 330,
      "דן סולומון": 580,
      "רן שמיר": 350,
      "יובל קליין": 275,
      "דניאל לוי": 660,
      "אור כהן": 500,
      "שלמה גבע": 700,
      "אריאל כהן": 330,
      "דן כהן": 580,
      "דניאל כהן": 660,
      "אור קליין": 500,
      "אריאל קליין": 330,
      "דן קליין": 580,
      "רן סולומון": 350,
      "יובל סולומון": 275,
      "דניאל סולומון": 660,
    },
    totalReportCompletedByControlCenter: 728,
    totalReportCompletedByControlCenterPercentage: 42,
  },
  policeStatistic: {
    maxSendToPolice: 200,
    currentSendToPolice: 120,
    sendPerPeriod: {
      ראשון: {
        send: 350,
        percentage: 33,
      },
      שני: {
        send: 420,
        percentage: 50,
      },
      שלישי: {
        send: 250,
        percentage: 16,
      },
      רביעי: {
        send: 210,
        percentage: 36,
      },
      חמישי: {
        send: 300,
        percentage: 56,
      },
      שישי: {
        send: 300,
        percentage: 76,
      },
      שבת: {
        send: 150,
        percentage: 46,
      },
    },
    totalSendByPeriod: 1240,
    totalSendByPeriodPercentage: 42,
  },
  lastCall: "13-05-2020 10:35",
};
